import { Injectable, Optional, inject } from '@angular/core';
import { of } from 'rxjs';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { ConvertHelper } from 'libs/abc/core/helpers';

@Injectable({ providedIn: 'root' })
export class BuildInfoService {
  private abcConfig: AbcConfigService = inject(AbcConfigService);
  constructor() {}

  public getFullVersion(): string {
    return this.abcConfig.getConfiguration()?.VersionInfo?.Full ?? '';
  }

  public getMainVersion(): string {
    return this.abcConfig.getConfiguration()?.VersionInfo?.Main ?? '';
  }

  public getBuildDate(): string {
    try {
      const fullVersion = this.abcConfig.getConfiguration()?.VersionInfo?.Full;

      if (fullVersion) {
        const parts = fullVersion.split('.');
        const buildDate = parts[3];

        if (!buildDate || buildDate.length < 5) {
          return '';
        }

        // Extract year (YY) and day of year (DDD)
        const year = 2000 + parseInt(buildDate.substring(0, 2), 10);
        const dayOfYear = parseInt(buildDate.substring(2, 5), 10);

        // Validate ranges
        if (isNaN(year) || isNaN(dayOfYear) || dayOfYear < 1 || dayOfYear > 366) {
          return '';
        }

        // Convert day of year to date
        const date = new Date(year, 0, dayOfYear);
        const formattedDate = ConvertHelper.toLocaleFormattedDateString(date);
        return formattedDate;
      }
    } catch (error) {
      console.error('Error parsing build date:', error);
    }
  }
}
